import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAdminAuth } from './AdminAuthContext';

const ROLE_ORDER = { editor: 0, admin: 1, super_admin: 2 };

function roleMeets(required, actual) {
  if (!actual) return false;
  const need = ROLE_ORDER[required] ?? 0;
  const have = ROLE_ORDER[actual] ?? 0;
  return have >= need;
}

/**
 * Wraps admin routes. Optional `minRole` gates sections (default: editor).
 */
export default function ProtectedRoute({ minRole = 'editor' }) {
  const { session, profile, loading } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center text-zinc-300">
        <div className="flex flex-col items-center gap-3">
          <div className="h-10 w-10 border-2 border-violet-500 border-t-transparent rounded-full animate-spin" />
          <p className="text-sm">Loading session…</p>
        </div>
      </div>
    );
  }

  if (!session?.user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!profile?.role || !roleMeets(minRole, profile.role)) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center px-4">
        <div className="max-w-md rounded-xl border border-zinc-800 bg-zinc-900/80 p-6 text-center text-zinc-200">
          <h1 className="text-lg font-semibold mb-2">Access denied</h1>
          <p className="text-sm text-zinc-400">
            Your account does not have permission to view this page. Ask a super
            admin to update your role in Supabase.
          </p>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
